import { date, Notify } from "quasar.src";

const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const displayWithBR = (text) => text.replace(/\n/g, "<br />");
const displayDateFormatIso = (value) =>
  date.formatDate(value, "DD/MM/YYYY à HH:mm");
const displayDateFormatDDMMYYYY = (value) =>
  date.formatDate(value, "DD/MM/YYYY");
const displayMillesimesNumber = (number) =>
  `Le fichier de données contient ${number} millésime${number > 1 ? "s" : ""}`;
const downloadBlob = (blob, name) => {
  // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
  const blobUrl = URL.createObjectURL(blob);

  // Create a link element
  const link = document.createElement("a");

  // Set link's href to point to the Blob URL
  link.href = blobUrl;
  link.download = name;

  // Append link to the body
  document.body.appendChild(link);

  // Dispatch click event on the link
  // This is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  );

  // Remove link from body
  document.body.removeChild(link);
};
const showNotification = (notif) => Notify.create({ ...notif, progress: true });
const formatMinDate = (value) => date.formatDate(value, "YYYY-MM-DD");
const formatMaxDate = (value) =>
  date.formatDate(date.addToDate(value, { days: 1 }), "YYYY-MM-DD");
const createCatalogFilter = (inputFilter) => {
  return {
    pagination: inputFilter.pagination || 1,
    itemsType: inputFilter.itemsType || "dataset",
    order: {
      field:
        inputFilter.order && inputFilter.order.field
          ? inputFilter.order.field
          : "last_modified",
      sort:
        inputFilter.order && inputFilter.order.sort
          ? inputFilter.order.sort
          : "desc",
    },
    text: inputFilter.text || "",
    lastModified: {
      min:
        inputFilter.lastModified && inputFilter.lastModified.min
          ? inputFilter.lastModified.min
          : "",
      max:
        inputFilter.lastModified && inputFilter.lastModified.max
          ? inputFilter.lastModified.max
          : "",
    },
    temporalCoverage: {
      from:
        inputFilter.temporalCoverage && inputFilter.temporalCoverage.from
          ? inputFilter.temporalCoverage.from
          : "",
      to:
        inputFilter.temporalCoverage && inputFilter.temporalCoverage.to
          ? inputFilter.temporalCoverage.to
          : "",
    },
    topics: inputFilter.topics || [],
    tags: inputFilter.tags || [],
    licenses: inputFilter.licenses || [],
    zones: inputFilter.zones || [],
    granularities: inputFilter.granularities || [],
    frequencies: inputFilter.frequencies || [],
  };
};
const cleanLinkedDocTitle = (title) => {
  try {
    let txtHtml = new DOMParser().parseFromString(title, "text/html");
    return txtHtml.documentElement.textContent;
  } catch (error) {
    return title;
  }
};
const cleanLinkedDocDescription = (description) => {
  try {
    return (
      description
        // unescape utf8
        .replace(/\\u([a-fA-F0-9]{4})/g, (matched, g1) =>
          String.fromCharCode(parseInt(g1, 16)),
        )
        // remove multiple br
        .replace(/(<br\s*\/?>(\r|\n|\s|\t)*)+/g, "<br>")
    );
  } catch (error) {
    return description;
  }
};
const copyLinkToClipboard = (link, parentHtmlEl) => {
  const el = document.createElement("textarea");
  el.value = link;
  parentHtmlEl.appendChild(el);
  el.select();
  document.execCommand("copy");
  parentHtmlEl.removeChild(el);
  showNotification({
    type: "info",
    message: "Le lien a été copié dans le presse-papier",
    position: "top",
    icon: "mdi-information",
    timeout: 2500,
  });
};
const createCatalogExploreFilterFromUrl = (url) => {
  const params = url.searchParams;
  const extractValue = (field, isArray, defaultValue) => {
    const fieldValue = params.get(field);
    if (isArray) return fieldValue ? fieldValue.split(",") : defaultValue;
    else return fieldValue || defaultValue;
  };
  return {
    pagination: extractValue("pagination", false, 1),
    itemsType: extractValue("type", false, "dataset"),
    order: {
      field: extractValue("sortField", false, "last_modified"),
      sort: extractValue("sortOrder", false, "desc"),
    },
    text: extractValue("text", false, ""),
    lastModified: {
      max: extractValue("modifiedBefore", false, ""),
      min: extractValue("modifiedAfter", false, ""),
    },
    temporalCoverage: {
      from: extractValue("temporalCoverageStart", false, ""),
      to: extractValue("temporalCoverageEnd", false, ""),
    },
    topics: extractValue("topics", true, []),
    tags: extractValue("tags", true, []),
    licenses: extractValue("licenses", true, []),
    zones: extractValue("zones", true, []),
    granularities: extractValue("granularities", true, []),
    frequencies: extractValue("frequencies", true, []),
  };
};
const createCatalogUrlFromExploreFilter = (exploreFilter) => {
  let url = `?page=explore&type=${
    exploreFilter.itemsType || "dataset"
  }&pagination=${exploreFilter.pagination || 1}`;
  if (exploreFilter.order)
    url = `${url}&sortField=${exploreFilter.order.field}&sortOrder=${exploreFilter.order.sort}`;
  if (exploreFilter.text) url = `${url}&text=${exploreFilter.text}`;
  if (exploreFilter.topics && exploreFilter.topics.length)
    url = `${url}&topics=${exploreFilter.topics.join(",")}`;
  if (exploreFilter.tags && exploreFilter.tags.length)
    url = `${url}&tags=${exploreFilter.tags.join(",")}`;
  if (exploreFilter.licenses && exploreFilter.licenses.length)
    url = `${url}&licenses=${exploreFilter.licenses.join(",")}`;
  if (exploreFilter.zones && exploreFilter.zones.length)
    url = `${url}&zones=${exploreFilter.zones.join(",")}`;
  if (exploreFilter.granularities && exploreFilter.granularities.length)
    url = `${url}&granularities=${exploreFilter.granularities.join(",")}`;
  if (exploreFilter.frequencies && exploreFilter.frequencies.length)
    url = `${url}&frequencies=${exploreFilter.frequencies.join(",")}`;
  if (exploreFilter.lastModified) {
    if (exploreFilter.lastModified.modifiedBefore)
      url = `${url}&modifiedBefore=${exploreFilter.lastModified.modifiedBefore}`;
    if (exploreFilter.lastModified.modifiedAfter)
      url = `${url}&modifiedAfter=${exploreFilter.lastModified.modifiedAfter}`;
  }
  if (exploreFilter.temporalCoverage) {
    if (exploreFilter.temporalCoverage.from)
      url = `${url}&temporalCoverageStart=${exploreFilter.temporalCoverage.from}`;
    if (exploreFilter.temporalCoverage.to)
      url = `${url}&temporalCoverageEnd=${exploreFilter.temporalCoverage.to}`;
  }
  return url;
};
const apiValueToLocaleString = (apiValue, type, precision = null) => {
  // if value is empty return empty string
  if (apiValue === null) return "";

  // if it's a boolean, stringify it
  if (type === "boolean")
    return [true, "true"].includes(apiValue) ? "Oui" : "Non";

  // if it's not a number return value
  if (!["number", "integer"].includes(type)) return apiValue;

  // api can return sring for numeric type (example: secret)
  if (Number.isNaN) return apiValue;

  // if it's an integer return localized value
  if (type === "integer")
    return Number(apiValue).toLocaleString(undefined, {
      maximumFractionDigits: 0,
    });

  // // if it's a number with precision return localized value with precision for fraction digits
  if (precision)
    return Number(apiValue).toLocaleString(undefined, {
      minimumFractionDigits: precision,
    });

  // finally it's a number without precision, we search the fraction digits in initial value and we return the localized value with this precision
  const valueSplitted = String(apiValue).split(".");
  const valuePrecision = valueSplitted[1] ? valueSplitted[1].length : 0;
  return Number(apiValue).toLocaleString(undefined, {
    minimumFractionDigits: valuePrecision,
  });
};

const exploreUrlOnLabelCard = (card, type, value) => {
  const typesInUrl = {
    tag: "tags",
    topic: "topics",
    frequency: "frequencies",
    granularity: "granularities",
    zone: "zones",
    license: "licenses",
  };
  return `?page=explore&type=${card}&${typesInUrl[type]}=${value}`;
};

export {
  pause,
  displayWithBR,
  displayDateFormatIso,
  displayDateFormatDDMMYYYY,
  displayMillesimesNumber,
  downloadBlob,
  showNotification,
  formatMinDate,
  formatMaxDate,
  createCatalogFilter,
  cleanLinkedDocTitle,
  cleanLinkedDocDescription,
  copyLinkToClipboard,
  createCatalogExploreFilterFromUrl,
  createCatalogUrlFromExploreFilter,
  exploreUrlOnLabelCard,
  apiValueToLocaleString,
};
